import { Props } from "../interfaces/layout";
import LayoutUnified from "./LayoutUnified";

const LayoutBarista = ({ children }: Props) => {
  return <LayoutUnified>{children}</LayoutUnified>;
};

export default LayoutBarista;
